import type { Translate } from '../../i18n';

/**
 * The report refusals, worded once for the builder, the saved list and the list layout.
 *
 * ⚠️ Moved out of `reports-route.tsx` on 16 Oct 2026, when the list layout became a third reader.
 */
export function messageFor(t: Translate, code: string, detail: string): string {
  if (code === 'metafield_not_groupable') return t('report.error.notGroupable');
  if (code === 'unknown_metafield') return t('report.error.unknownMetafield');
  if (code === 'unknown_filter_target') return t('report.error.unknownFilter', { field: detail });
  /* 16 Oct 2026 · the list layout's two. */
  if (code === 'unknown_report_column') return t('report.error.unknownColumn');
  if (code === 'bad_report_filter') return t('report.error.badFilter');
  /* 17 Oct 2026 · the timeline's: more periods than it draws. */
  if (code === 'report_period_too_long') return t('report.error.periodTooLong');
  if (code === 'conflict') return t('error.conflict');
  if (code === 'not_found') return t('error.not_found');
  return t('error.unavailable');
}

export async function envelopeOf(response: Response): Promise<{ code: string; detail: string }> {
  const body = (await response.json().catch(() => null)) as {
    error?: { code?: string; details?: { code?: string; message?: string }[] };
  } | null;
  return {
    code: body?.error?.code ?? 'unavailable',
    detail: body?.error?.details?.[0]?.code ?? '',
  };
}
